import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
  selector: 'am-benefits-banner',
  styleUrls: ['./benefits-banner.component.scss'],
  templateUrl: './benefits-banner.component.html',
})
export class BenefitsBannerComponent implements AfterViewInit {
  @Input()
  public isDisney: boolean;
  @Input()
  public isUniversal: boolean;

  public openPanel = true;

  public temporarilyHidden = true;

  public disneyURl = '/hotels/results/dist/es-AR/assets/images/Operador selecto.svg';

  public universalUrl =
    '/hotels/results/dist/es-AR/assets/images/benefits-banner/proveedorOficialUniversal2023.png';

  public altImage = '';
  constructor() {}

  public togglePanel() {
    this.openPanel = !this.openPanel;
  }

  public ngAfterViewInit(): void {
    this.altImage = `Operador selecto vacaciones en ${
      this.isDisney ? 'Walt Disney Word' : 'Universal'
    }`;
  }
}
